"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Player = void 0;
const models_1 = require("lincd/lib/models");
const package_1 = require("../package");
const schema_1 = require("lincd-schema/lib/ontologies/schema");
const Person_1 = require("profile-plus/lib/shapes/Person");
const ShapeDecorators_1 = require("lincd/lib/utils/ShapeDecorators");
const irlcg_1 = require("../ontologies/irlcg");
const Team_1 = require("./Team");
const Boolean_1 = require("lincd-xsd/lib/shapes/Boolean");
const Server_1 = require("lincd-server-utils/lib/utils/Server");
let Player = class Player extends Person_1.Person {
    //TODO Abhi: add get/set currentTeam:Team
    get currentTeam() {
        return this.getOneAs(irlcg_1.irlcg.currentTeam, Team_1.Team);
    }
    set currentTeam(val) {
        this.overwrite(irlcg_1.irlcg.currentTeam, val.namedNode);
    }
    //TODO: get/set withoutAuthentication
    get withoutAuthentication() {
        return Boolean_1.Boolean.isTrue(this.getOne(irlcg_1.irlcg.withoutAuthentication));
    }
    set withoutAuthentication(val) {
        this.overwrite(irlcg_1.irlcg.withoutAuthentication, val ? Boolean_1.Boolean.true() : Boolean_1.Boolean.false());
    }
    get attendance() {
        return this.getValue(irlcg_1.irlcg.attendance);
    }
    set attendance(val) {
        this.overwrite(irlcg_1.irlcg.attendance, new models_1.Literal(val));
    }
    static getSubPlayers() {
        return Server_1.Server.call(this, 'getSubPlayers');
    }
    isInCertainMode(teamName) {
        var _a;
        //e.g. trial mode
        const isCertainMode = (_a = this === null || this === void 0 ? void 0 : this.currentTeam) === null || _a === void 0 ? void 0 : _a.uri.includes(teamName);
        return isCertainMode;
    }
    // check current mode user who signup from event registration
    isEventMode() {
        var _a;
        const isEventMode = (_a = this === null || this === void 0 ? void 0 : this.currentTeam) === null || _a === void 0 ? void 0 : _a.uri.includes('event-teams');
        return isEventMode;
    }
};
exports.Player = Player;
Player.targetClass = schema_1.schema.Person;
__decorate([
    (0, ShapeDecorators_1.objectProperty)({
        path: irlcg_1.irlcg.currentTeam,
    }),
    __metadata("design:type", Team_1.Team),
    __metadata("design:paramtypes", [Team_1.Team])
], Player.prototype, "currentTeam", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: irlcg_1.irlcg.withoutAuthentication,
        dataType: Boolean_1.Boolean.targetClass,
    }),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], Player.prototype, "withoutAuthentication", null);
__decorate([
    (0, ShapeDecorators_1.literalProperty)({
        path: irlcg_1.irlcg.attendance,
        maxCount: 1,
    }),
    __metadata("design:type", String),
    __metadata("design:paramtypes", [String])
], Player.prototype, "attendance", null);
exports.Player = Player = __decorate([
    package_1.linkedShape
], Player);
//# sourceMappingURL=Player.js.map